import { atom } from 'recoil';

export const selectedConsultationIdsState = atom<number[]>({
  key: 'selectedConsultationIds',
  default: [],
});

export const consultationIdsToAssignState = atom<number[]>({
  key: 'consultationIdsToAssign',
  default: [],
});

export const consultationAtoms = [selectedConsultationIdsState, consultationIdsToAssignState];
